import { HIDE_MENU, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    hideMenu: true,
}

export const hideMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case HIDE_MENU:
            return {
                ...state,
                hideMenu: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}